import axios from "axios";
import Auth from "../common/Auth";
function them(khachHang){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/khachhang/them",khachHang);
};
function getAll(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/khachhang/getall");
};
function timKiemChinhXac(key){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/khachhang/timkiemchinhxac?key="+key);
};
function capNhat(khachHang){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/khachhang/capnhat",khachHang);
};
function uuTien(khachHang){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/khachhang/uutien",khachHang);
};
function theoDoi(khachHang){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/khachhang/theodoi",khachHang);
};
function xoa(ids){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/khachhang/xoa",ids);
};
function importFile(file){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/khachhang/import",file);
};
function saveImportFile(listKH){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/khachhang/savelist",listKH);
};
function getSoLuongKhachHangTheoDVHC(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/khachhang/soluongkhtheodvhc");
};
function getUrlPage(listQuyen, roleUser) {
  if (Auth.checkUrl("/cus/khachhang/getall", listQuyen, roleUser)) {
      return process.env.REACT_APP_URL_SERVER + "/cus/khachhang/getpage";
  }
  else return process.env.REACT_APP_URL_SERVER + "/cus/personal/khachhang/getpage";
};
function getUrlSearch(key, listQuyen, roleUser) {
  if (Auth.checkUrl("/cus/khachhang/getall", listQuyen, roleUser)) {
      return process.env.REACT_APP_URL_SERVER + "/cus/khachhang/search?key=" + key;
  } else return process.env.REACT_APP_URL_SERVER + "/cus/personal/khachhang/search?key=" + key;

};
const HhachHangService={
  getUrlSearch,
  getSoLuongKhachHangTheoDVHC,
  timKiemChinhXac,
  them,
  getAll,
  capNhat,
  xoa,
  importFile,
  uuTien,
  theoDoi,
  saveImportFile,
  getUrlPage

};
export default HhachHangService;
